<template>
  <div></div>
</template>

<script>
export default {
  mounted() {
    localStorage.setItem('accessToken', this.$route.params.token)
    this.$http.defaults.headers.common.Authorization =
      'Bearer ' + this.$route.params.token
    localStorage.setItem('uname', this.$route.params.uname)
    this.$router.push('/instances')
  }
}
</script>

<style>
</style>
